import router from '../router/index'
import axios from 'axios'
import i18n from '../i18n'
export default {
    state: {
        newShippingTest: {},
        editingShippingTest: {},
        newTouristTest: {},
        editingTouristTest: {},
        newCellexTest: {}
    },

    mutations: {
        nullNewShippingTest(state) {
            state.newShippingTest = {}
        },
        newShippingTestFirst(state, credentials) {
            state.newShippingTest = Object.assign({
                interviewDate: credentials.interviewDate,
                caseCode: credentials.caseCode,
                orgCode: credentials.orgCode,
                lastName: credentials.lastName,
                firstName: credentials.firstName,
                passportNo: credentials.passportNo,
                email: credentials.email,
                reportType: 'shipping',
                result: "PENDING",
                formJsonText: Object.assign({
                    fullAddress: credentials.formJsonText.fullAddress,
                    patientProfile: credentials.formJsonText.patientProfile,
                    permanentAddress: credentials.formJsonText.permanentAddress,
                    currentAddress: credentials.formJsonText.currentAddress,
                    addressOutside: credentials.formJsonText.addressOutside

                })

            })
        },

        newShippingTestSecond(state, credentials) {
            state.newShippingTest.formJsonText = Object.assign({
                patientProfile: state.newShippingTest.formJsonText.patientProfile,
                permanentAddress: state.newShippingTest.formJsonText.permanentAddress,
                currentAddress: state.newShippingTest.formJsonText.currentAddress,
                addressOutside: state.newShippingTest.formJsonText.addressOutside,
                travelHistory: credentials.travelHistory,
                exposureHistory: credentials.exposureHistory,
                clinicalInformation: credentials.clinicalInformation

            })
        },

        newShippingTestThird(state, credentials) {
            state.newShippingTest.result = credentials.classification
            state.newShippingTest.formJsonText = Object.assign({
                fullAddress: state.newShippingTest.formJsonText.fullAddress,
                patientProfile: state.newShippingTest.formJsonText.patientProfile,
                permanentAddress: state.newShippingTest.formJsonText.permanentAddress,
                currentAddress: state.newShippingTest.formJsonText.currentAddress,
                addressOutside: state.newShippingTest.formJsonText.addressOutside,
                travelHistory: state.newShippingTest.formJsonText.travelHistory,
                exposureHistory: state.newShippingTest.formJsonText.exposureHistory,
                clinicalInformation: state.newShippingTest.formJsonText.clinicalInformation,
                specimentInformation: credentials.specimentInformation,
                classification: credentials.classification,
                outcome: credentials.outcome,

            })
        },

        setEditingShippingTest(state, credentials) {
            state.editingShippingTest = { ...credentials }
        },

        editShippingTestFirst(state, credentials) {
            console.log(credentials)
            state.editingShippingTest.caseCode = credentials.caseCode
            state.editingShippingTest.orgCode = credentials.orgCode
            state.editingShippingTest.interviewDate = credentials.interviewDate
            state.editingShippingTest.lastName = credentials.lastName
            state.editingShippingTest.firstName = credentials.firstName
            state.editingShippingTest.passportNo = credentials.passportNo
            state.editingShippingTest.email = credentials.email
            state.editingShippingTest.reportType = 'shipping'

            state.editingShippingTest.formJsonText.fullAddress = credentials.formJsonText.fullAddress

            state.editingShippingTest.formJsonText.patientProfile = credentials.formJsonText.patientProfile
            state.editingShippingTest.formJsonText.permanentAddress = credentials.formJsonText.permanentAddress
            state.editingShippingTest.formJsonText.currentAddress = credentials.formJsonText.currentAddress
            state.editingShippingTest.formJsonText.addressOutside = credentials.formJsonText.addressOutside
        },

        editShippingTestSecond(state, credentials) {
            state.editingShippingTest.formJsonText.travelHistory = credentials.travelHistory
            state.editingShippingTest.formJsonText.exposureHistory = credentials.exposureHistory
            state.editingShippingTest.formJsonText.clinicalInformation = credentials.clinicalInformation
        },

        editShippingTestThird(state, credentials) {
            state.editingShippingTest.result = credentials.classification
            state.editingShippingTest.formJsonText = Object.assign({
                fullAddress: state.editingShippingTest.formJsonText.fullAddress,
                patientProfile: state.editingShippingTest.formJsonText.patientProfile,
                permanentAddress: state.editingShippingTest.formJsonText.permanentAddress,
                currentAddress: state.editingShippingTest.formJsonText.currentAddress,
                addressOutside: state.editingShippingTest.formJsonText.addressOutside,
                travelHistory: state.editingShippingTest.formJsonText.travelHistory,
                exposureHistory: state.editingShippingTest.formJsonText.exposureHistory,
                clinicalInformation: state.editingShippingTest.formJsonText.clinicalInformation,
                specimentInformation: credentials.specimentInformation,
                classification: credentials.classification,
                outcome: credentials.outcome
            })
        },

        nullEditShippingTest(state) {
            state.editingShippingTest = {}
        },

        newTouristTestFirst(state, credentials) {
            state.newTouristTest = Object.assign({
                caseCode: credentials.caseCode,
                orgCode: credentials.orgCode,
                interviewDate: new Date().getTime(),
                lastName: credentials.lastName,
                firstName: credentials.firstName,
                passportNo: credentials.passportNo,
                email: credentials.email,
                reportType: 'tourist',
                result: 'PENDING',
                formJsonText: Object.assign({
                    flightInfo: credentials.formJsonText.flightInfo,
                    personalInfo: credentials.formJsonText.personalInfo,
                    contactInfo: credentials.formJsonText.contactInfo,
                    temporaryAddress: credentials.formJsonText.temporaryAddress,
                    emergencyContactInfo: credentials.formJsonText.emergencyContactInfo,
                    family: credentials.formJsonText.family,
                    quarantinePlace: credentials.formJsonText.quarantinePlace
                })
            })
        },

        newTouristTestSecond(state, credentials) {
            state.newTouristTest.formJsonText = Object.assign({
                flightInfo: state.newTouristTest.formJsonText.flightInfo,
                personalInfo: state.newTouristTest.formJsonText.personalInfo,
                contactInfo: state.newTouristTest.formJsonText.contactInfo,
                permanentAddress: state.newTouristTest.formJsonText.permanentAddress,
                temporaryAddress: state.newTouristTest.formJsonText.temporaryAddress,
                emergencyContactInfo: state.newTouristTest.formJsonText.emergencyContactInfo,
                family: state.newTouristTest.formJsonText.family,
                quarantinePlace: state.newTouristTest.formJsonText.quarantinePlace,
                questionnaire: credentials.questionnaire
            })
        },

        newTouristTestThird(state, credentials) {
            state.newTouristTest.formJsonText = Object.assign({
                flightInfo: state.newTouristTest.formJsonText.flightInfo,
                personalInfo: state.newTouristTest.formJsonText.personalInfo,
                contactInfo: state.newTouristTest.formJsonText.contactInfo,
                permanentAddress: state.newTouristTest.formJsonText.permanentAddress,
                temporaryAddress: state.newTouristTest.formJsonText.temporaryAddress,
                emergencyContactInfo: state.newTouristTest.formJsonText.emergencyContactInfo,
                family: state.newTouristTest.formJsonText.family,
                quarantinePlace: state.newTouristTest.formJsonText.quarantinePlace,
                questionnaire: state.newTouristTest.formJsonText.questionnaire,
                medical: credentials.medical
            })
        },

        nullNewTouristTest(state) {
            state.newTouristTest = {}
        },

        setEditingTouristTest(state, credentials) {
            state.editingTouristTest = { ...credentials }
        },

        editTouristTestFirst(state, credentials) {
            state.editingTouristTest.investigatorName = credentials.investigatorName
            state.editingTouristTest.interviewDate = credentials.interviewDate
            state.editingTouristTest.lastName = credentials.lastName
            state.editingTouristTest.reportingUser = credentials.reportingUser
            state.editingTouristTest.firstName = credentials.firstName
            state.editingTouristTest.passportNo = credentials.passportNo
            state.editingTouristTest.email = credentials.email
            state.editingTouristTest.reportType = 'tourist'
            state.editingTouristTest.formJsonText.flightInfo = credentials.formJsonText.flightInfo
            state.editingTouristTest.formJsonText.personalInfo = credentials.formJsonText.personalInfo
            state.editingTouristTest.formJsonText.contactInfo = credentials.formJsonText.contactInfo
            state.editingTouristTest.formJsonText.temporaryAddress = credentials.formJsonText.temporaryAddress
            state.editingTouristTest.formJsonText.emergencyContactInfo = credentials.formJsonText.emergencyContactInfo
            state.editingTouristTest.formJsonText.family = credentials.formJsonText.family
            state.editingTouristTest.formJsonText.quarantinePlace = credentials.formJsonText.quarantinePlace
        },

        editTouristTestSecond(state, credentials) {
            state.editingTouristTest.formJsonText.questionnaire = credentials.questionnaire
        },

        editTouristTestThird(state, credentials) {
            state.editingTouristTest.formJsonText = Object.assign({
                flightInfo: state.editingTouristTest.formJsonText.flightInfo,
                personalInfo: state.editingTouristTest.formJsonText.personalInfo,
                contactInfo: state.editingTouristTest.formJsonText.contactInfo,
                temporaryAddress: state.editingTouristTest.formJsonText.temporaryAddress,
                emergencyContactInfo: state.editingTouristTest.formJsonText.emergencyContactInfo,
                family: state.editingTouristTest.formJsonText.family,
                quarantinePlace: state.editingTouristTest.formJsonText.quarantinePlace,
                questionnaire: state.editingTouristTest.formJsonText.questionnaire,
                medical: credentials.medical
            })
        },
        newCellexTestFirst(state, credentials) {
            state.newCellexTest = {
                ...state.newCellexTest,
                personalInfo: {
                    firstName: credentials.firstName,
                    lastName: credentials.lastName,
                    idNumber: credentials.idNumber,
                    gender: credentials.gender,
                    birthDate: credentials.birthDate,
                    orgCode: credentials.orgCode,
                    country: credentials.country,
                    nationality: credentials.nationality,
                    city: credentials.city,
                    address: credentials.address,
                    postalCode: credentials.postalCode,
                    phone: credentials.phone,
                    email: credentials.email
                }
            }
        },
        newCellexTestSecond(state, credentials) {
            state.newCellexTest = {
                ...state.newCellexTest,
                tripInfo: {
                    tripType: credentials.tripType,
                    accompanied: credentials.accompanied,
                    peopleAccompanied: credentials.accompanied ? credentials.peopleAccompanied : null,
                    arrivalPlace: credentials.arrivalPlace,
                    departurePlace: credentials.departurePlace,
                    residencePlace: credentials.residencePlace,
                    transportMean: credentials.transportMean,
                    travelDates: credentials.travelDates,
                    stayingDays: credentials.stayingDays
                }
            }
        },
        newCellexTestThird(state, credentials) {
            state.newCellexTest = {
                ...state.newCellexTest,
                questionnaire: {
                    ...credentials.questionnaire
                }
            }
        },
        nullNewCellexTest(state) {
            state.newCellexTest = {}
        }
    },

    actions: {
        newShippingTestFirst({ commit }, credentials) {
            commit('newShippingTestFirst', credentials)
            router.push('third')
        },

        newShippingTestSecond({ commit }, credentials) {
            commit('newShippingTestSecond', credentials)
            router.push('third')
        },

        newShippingTestThird({ commit, state }, credentials) {
            commit('newShippingTestThird', credentials)
            axios.post(`${process.env.VUE_APP_BASE_URL}/case/`, state.newShippingTest)
                .then(res => {
                    console.log(res)
                    router.push('/frontDesk/dashboard')
                    commit('nullNewShippingTest')
                })
                .catch(err => {
                    console.log(err)
                })

        },

        setEditingShippingTest({ commit }, credentials) {
            commit('setEditingShippingTest', credentials)
            router.push('/frontDesk/shippingTest/edit/first')
        },

        editShippingTestFirst({ commit }, credentials) {
            commit('editShippingTestFirst', credentials)
            router.push('third')
        },

        editShippingTestSecond({ commit }, credentials) {
            commit('editShippingTestSecond', credentials)
            router.push('third')
        },

        editShippingTestThird({ commit, state }, credentials) {
            commit('editShippingTestThird', credentials)
            axios.put(`${process.env.VUE_APP_BASE_URL}/case/${state.editingShippingTest.testId}`, state.editingShippingTest)
                .then(res => {
                    console.log(res)
                    commit('nullEditShippingTest')
                    router.push('/frontDesk/dashboard')
                })
                .catch(err => {
                    console.log(err)
                })
        },

        newTouristTestFirst({ commit }, credentials) {
            commit('newTouristTestFirst', credentials)
            router.push('second')
        },

        newTouristTestSecond({ commit }, credentials) {
            commit('newTouristTestSecond', credentials)
            router.push('third')
        },

        newTouristTestThird({ commit, state }, credentials) {
            commit('newTouristTestThird', credentials)
            axios.post(`${process.env.VUE_APP_BASE_URL}/case/`, state.newTouristTest)
                .then(res => {
                    console.log(res)
                    router.push('/frontDesk/dashboard')
                    commit('nullNewTouristTest')
                })
                .catch(err => {
                    console.log(err)
                })
        },

        setEditingTouristTest({ commit }, credentials) {
            commit('setEditingTouristTest', credentials)
            router.push('/frontDesk/touristTest/edit/first')
        },

        editTouristTestFirst({ commit }, credentials) {
            commit('editTouristTestFirst', credentials)
            router.push('second')
        },

        editTouristTestSecond({ commit }, credentials) {
            commit('editTouristTestSecond', credentials)
            router.push('third')
        },

        editTouristTestThird({ commit, state }, credentials) {
            commit('editTouristTestThird', credentials)
            axios.put(`${process.env.VUE_APP_BASE_URL}/case/${state.editingTouristTest.testId}`, state.editingTouristTest)
                .then(res => {
                    commit('nullEditTouristTest')
                    router.push('/frontDesk/dashboard')
                })
                .catch(err => {
                    console.log(err)
                })
        },
        newCellexTestFirst({ commit }, credentials) {
            commit('newCellexTestFirst', credentials)
            router.push("/frontDesk/cellexTest/third");
        },
        newCellexTestSecond({ commit }, credentials) {
            commit('newCellexTestSecond', credentials)
            router.push("/frontDesk/cellexTest/third");
        },
        newCellexTestThird({ commit }, credentials) {
            commit('newCellexTestThird', credentials)
            router.push("/frontDesk/cellexTest/fourth");
        },
        newCellexTestFourth({ commit, state }, credentials) {
            axios.post(`${process.env.VUE_APP_BASE_URL}/case/`, {
                firstName: state.newCellexTest.personalInfo.firstName,
                lastName: state.newCellexTest.personalInfo.lastName,
                email: state.newCellexTest.personalInfo.email,
                orgCode: !!state.newCellexTest.personalInfo.orgCode ? state.newCellexTest.personalInfo.orgCode : 'dummyCode',
                //investigatorName: 'giannis',
                passportNo: state.newCellexTest.personalInfo.idNumber,
                reportType: 'cellex',
                caseCode: '',
                // reportingUser: 'giannis',
                testId: null,
                interviewDate: new Date(),
                //illnessOnsetDate: null,
                //admissionDate: null,
                //dischargeDate: null,
                result: credentials.isPositive,
                formJsonText: {
                    ...state.newCellexTest,
                    results: {
                        isPositive: credentials.isPositive,
                        temperature: credentials.temperature,
                        serialNumber: credentials.serialNumber,
                        testType : credentials.testType
                    }
                }
            })
                .then(res => {
                    console.log(res)
                    console.log('cred', credentials)
                    let formData = new FormData()
                    formData.append("file", credentials.file)
                    console.log(formData.get("file"))
                    return axios.post(`${process.env.VUE_APP_BASE_URL}/case/${res.data.testId}/file`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })

                })
                .then(res => {
                    router.push({ path: "/frontDesk/dashboard" });
                    commit('nullNewCellexTest')
                })
                .catch(err => {
                    console.log(err)
                })
        },
        newCellexTestPersonal({ commit }, credentials) {
            axios.post(`${process.env.VUE_APP_BASE_URL}/case/`, {
                firstName: credentials.firstName,
                lastName: credentials.lastName,
                email: credentials.email,
                orgCode: !!state.newCellexTest.personalInfo.orgCode ? state.newCellexTest.personalInfo.orgCode : 'dummyCode',
                passportNo: credentials.idNumber,
                reportType: 'cellex',
                caseCode: '',
                testId: null,
                interviewDate: new Date(),
                result: false,
                formJsonText: null
            })
                .then(res => {
                    console.log(res)
                    router.push({ path: "/frontDesk/dashboard" });
                })
                .catch(err => {
                    console.log(err)
                })
        },
        setLocale() {
            if (sessionStorage.getItem('userName') == 'bioiatrikiFront') {
                i18n.locale = 'el'
            }
        }
    },

}